import { CultureInfo } from '../culture-info.model';
import { CultureInfoSr } from './sr';

/**
 * @ignore
 */
export const CultureInfoSrLatn: CultureInfo = {
  name: 'sr-Latn',
  displayName: 'Serbian (Latin)',
  iso3LanguageCode: 'srp',
  iso2LanguageCode: 'sr',
  ietfLanguageTag: 'sr-Latn',
  parent: CultureInfoSr
};
